<template>
  <div class="create column">
    <Header />
    <form class="content" onsubmit="return false" @submit="saveUser">
      <div class="title">DADOS PESSOAIS</div>
      <div class="row column-s">
        <div class="column field font-12 grid-3 grid-12-s">
          <label>Confirme seu nome:</label>
          <input
            type="text"
            v-model="dados.nome"
            placeholder="Nome"
            pattern="(\w.+\s).+"
            title="Informar nome completo"
            required
          />
        </div>
        <div class="column field font-12 grid-3 grid-12-s">
          <label>Confirme seu celular:</label>
          <input
            v-model="dados.celular"
            type="text"
            placeholder="Celular"
            required
            v-mask="'(##) #####-####'"
          />
        </div>
        <div class="column field font-12 grid-3 grid-12-s">
          <label>Seu CEP:</label>
          <input
            v-model="dados.cep"
            @change="cep"
            type="text"
            placeholder="CEP"
            required
            v-mask="'##.###-###'"
            pattern="\d{2}.\d{3}-?\d{3}"
          />
        </div>
        <transition name="fade">
          <div v-if="dados.cidade" class="column field font-12 grid-3">
            <label>Cidade/UF</label>
            <div class="city">{{ dados.cidade + " / " + dados.estado }}</div>
          </div>
        </transition>
      </div>
      <div class="title margin-top">USUÁRIO PORTAL</div>
      <div class="row column-s">
        <div class="column field font-12 grid-3 grid-12-s">
          <label>E-mail:</label>
          <div class="city">{{ dados.email }}</div>
        </div>
        <div class="column field font-12 grid-3 grid-12-s">
          <label>Sua senha:</label>
          <input type="password" v-model="dados.senha" placeholder="Senha" required />
        </div>
        <div class="column field font-12 grid-3 grid-12-s">
          <label>Confirme sua senha:</label>
          <input
            type="password"
            v-model="dados.confirma_senha"
            placeholder="Confirme sua senha"
            required
          />
        </div>
      </div>

      <div class="row justify-center margin-top">
        <Button :loader="loader" layout="green-m" :disabled="address">GRAVAR</Button>
      </div>
    </form>

    <Status />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Header from "@/components/HeaderPage.vue";
import Button from "@/components/Button.vue";
import Status from "@/components/Status.vue";

import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
  name: "CreateSupporter",
  components: {
    Button,
    Status,
    Header,
  },
  data() {
    return {
      dados: { logradouro: "", cep: "", estado: "", cidade: "", bairro: "" },
      loader: false,
      address: true,
    };
  },
  methods: {
    ...mapActions("user", ["TOKEN_SUPPORTER", "SAVE_SUPPORTER"]),
    ...mapActions("general", ["LOAD_CEP"]),
    ...mapMutations("general", ["SET_STATUS"]),
    cep() {
      if (this.dados.cep.length > 9)
        this.LOAD_CEP(this.dados.cep.replace(".", "").replace("-", "")).then((r) => {
          this.address = true;
          this.SET_STATUS({ text: "CEP inválido", color: "red" });
          if (r.localidade) {
            this.dados.logradouro = r.logradouro;
            this.dados.bairro = r.bairro;
            this.dados.cidade = r.localidade;
            this.dados.estado = r.uf;
            this.address = false;
          } else {
            this.SET_STATUS({ text: "CEP inválido", color: "red" });
          }
        });
    },
    saveUser() {
      this.loader = true;
      if (this.dados.senha !== this.dados.confirma_senha) {
        this.loader = false;
        this.SET_STATUS({ text: "Senhas não coincidem", color: "red" });
      } else {
        let newData = Object.assign({}, this.dados);
        this.SAVE_SUPPORTER(newData).then(() => (this.loader = false));
      }
    },
  },
  beforeMount() {
    this.TOKEN_SUPPORTER(this.$route.params.token).then((r) => {
      if (r) this.dados = r;
    });
  },
  computed: {
    ...mapGetters("general", ["status"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.create {
  .content {
    border-radius: 4px;
    background: $white;
    box-shadow: $shadow;
    padding: 32px 35px;

    @media (min-width: $small) {
      margin: 30px;
    }

    .title {
      font-size: 24px;
      margin-bottom: 20px;
      color: $gray-2;
    }
    .field {
      padding-right: 15px;
      margin-top: 20px;
    }
    .city {
      font-size: 16px;
      margin-bottom: 35px;
      margin-top: 15px;
      font-weight: 500;
      color: $gray-5;
    }
    .margin-top {
      margin-top: 55px;
    }
    .label {
      color: $gray-6;
      font-size: 15px;
      font-weight: 300;
      margin-bottom: 25px;
      padding-right: 15px;
      select {
        width: 100%;
      }
      div {
        color: $gray-7;
        font-size: 15px;
        font-weight: 500;
        text-transform: capitalize;
      }
    }
    .section {
      padding-bottom: 40px;
    }
  }
  input {
    background: #fafafa 0% 0% no-repeat padding-box;
    border: 1px solid $white-6;
    border-radius: 5px;
    opacity: 1;
    height: 47px;
    width: 90%;
    padding: 0px 5%;
    margin-top: 7px;
    color: $gray-2;

    &:focus {
      background: $green-3;
      border-bottom: 5px solid $green-2;
    }
  }
}
</style>
